import { useCallback } from 'react';

import { ApolloQueryResult } from '@apollo/client';

import {
  GetBusinessPartnerPersonsResponse,
  GetBusinessPartnerPersonsVariables
} from '../types';

import { FormikContextType } from 'formik';

interface FieldUpdate {
  path: string; // formik field path
  value: any; // value to set
}

interface Params {
  personId: string;
  name: string;
  fieldUpdates: FieldUpdate[]; // <-- array of updates
}

export const useHandlePersonDrawerSuccess = (
  setPersonsOptions: React.Dispatch<
    React.SetStateAction<Record<string, string>>
  >,
  setFieldValue: FormikContextType<any>['setFieldValue'],
  refetchPersons: (
    variables?: Partial<GetBusinessPartnerPersonsVariables>
  ) => Promise<ApolloQueryResult<GetBusinessPartnerPersonsResponse>>,
  setFieldTouched?: FormikContextType<any>['setFieldTouched'],
  setFieldError?: FormikContextType<any>['setFieldError']
) => {
  const handlePersonDrawerSubmit = useCallback(
    async ({ personId, name, fieldUpdates }: Params) => {
      // Refetch LOV
      refetchPersons();

      // update LOV option list
      setPersonsOptions((prev) => ({
        ...prev,
        [personId]: name
      }));

      // apply multiple Formik field updates
      for (const { path, value } of fieldUpdates) {
        await setFieldValue(path, value, false);
        // Clear touched state and errors for the field when setting programmatically
        if (setFieldTouched) {
          await setFieldTouched(path, false, false);
        }
        if (setFieldError) {
          await setFieldError(path, undefined);
        }
      }
    },
    [setPersonsOptions, setFieldValue, refetchPersons]
  );

  return { handlePersonDrawerSubmit };
};
